"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  axios: true
};
Object.defineProperty(exports, "axios", {
  enumerable: true,
  get: function () {
    return _axios.default;
  }
});
var _axios = _interopRequireWildcard(require("axios"));
Object.keys(_axios).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _axios[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _axios[key];
    }
  });
});
var _createAxiosWithCache = require("./createAxiosWithCache");
Object.keys(_createAxiosWithCache).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createAxiosWithCache[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createAxiosWithCache[key];
    }
  });
});
var _joinPathSegments = require("./joinPathSegments");
Object.keys(_joinPathSegments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _joinPathSegments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _joinPathSegments[key];
    }
  });
});
var _SafeURL = require("./SafeURL");
Object.keys(_SafeURL).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SafeURL[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SafeURL[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//# sourceMappingURL=index.js.map